import React, { useMemo, useState } from 'react';
import ReactSelect from 'react-select';

import { useBreakpoint } from '@context/BreakpointProvider';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { mq } from '@helpers/breakpoints';
import Colors from '@theme/colors';

interface FormSelectProps {
  options: [{ value: string; label: string }];
  name: string;
  value: string;
  error?: boolean;
  placeholder: string;
  size: { width: number };
  dataI: string;
  setFieldValue(name: string, value: string): void;
  onChange(e: any): void;
}

const customStyles = (isMobile: boolean, error: boolean) => {
  return {
    option: (provided: any, state: any) => ({
      ...provided,
    }),
    control: (provided: any, state: any) => {
      // Note: extra 2px is for align select height with other elements
      return {
        ...provided,
        height: '56px',
        borderColor: error ? Colors.redLight1 : Colors.grayLight9,
        backgroundColor: error ? Colors.redLight4 : Colors.neutral0,
        maxHeight: '56px',
        borderRadius: '8px',
      };
    },
    valueContainer: (provided: any, state: any) => {
      return { ...provided, overflow: 'visible', height: '56px' };
    },
    singleValue: (provided: any, state: any) => {
      return { ...provided, fontSize: '1em' };
    },
    container: (provided: any) => {
      return { ...provided, width: '100%' };
    },
  };
};

const FormSelectStyle = () => css`
  ${mq({
    fontSize: '1em',
    height: ['56px'],
    borderWidth: '2px',
    borderStyle: 'solid',
    borderRadius: '8px',
    width: '100%',
    color: `${Colors.neutral75}`,
  })};
`;

const FormSelect = ({
  options,
  name,
  value,
  setFieldValue,
  onChange,
  placeholder = '',
  error,
  dataI,
}: FormSelectProps) => {
  const option = useMemo(() => {
    const val = options.find((item) => item.value + '' === value + '');
    return val ? val : '';
  }, [value]);
  const [menuOpened, openMenu] = useState(false);
  const { isMobile } = useBreakpoint();
  // console.log(props);
  return (
    <ReactSelect
      classNamePrefix={`${name}-select`}
      onChange={(e: { label: string; value: string }) => {
        // Date select types have a specific way of handling events
        openMenu(false);
        if (name === 'month' || name === 'day') {
          onChange(e);
        } else {
          setFieldValue(name, e.value);
        }
      }}
      blurInputOnSelect={true}
      onFocus={() => openMenu(true)}
      onBlur={() => openMenu(false)}
      styles={customStyles(isMobile, error)}
      options={options}
      value={option}
      components={{
        IndicatorSeparator: () => null,
      }}
      placeholder={placeholder}
      menuIsOpen={menuOpened}
      isSearchable={false}
      data-i={dataI}
    />
  );
};

const FormSelectStyled = styled(FormSelect)`
  ${FormSelectStyle}
`;

export { FormSelectStyled as FormSelect };
